import { render, staticRenderFns } from "./ExamResultsComponent.vue?vue&type=template&id=708f89bd&"
import script from "./ExamResultsComponent.vue?vue&type=script&lang=js&"
export * from "./ExamResultsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports